import { post, get } from '../network/index.js'
// 查询适用店铺(分页)
const listStoreInfoByMercId = data => {
  return post('/mercWebi/busStoreInfo/listStoreInfoByMercId', data)
}
//下拉选择店铺
const getStoreDownList = data => {
  return post('/mercWebi/orderCode/getStoreDownList', data)
}
//查询适用店铺
const getApplicaStore = data => {
  return post('mercWebi/orderCode/getApplicaStore', data)
}
//根据店铺获取频道信息
const channalList = data => {
  return post('/mercWebi/attachment/channalList', data)
}
//店铺列表
const queryStoresListForMerc = data => {
  return post('/mercWebi/busStoreInfo/queryStoresListForMerc', data)
}
//新增店铺
const insertStoreForMerc = data => {
  return post('/mercWebi/busStoreInfo/insertStoreForMerc', data)
}
//获取店铺详情
const listStoreById = data => {
  return get('/mercWebi/busStoreInfo/listStoreById', data)
}
//修改店铺
const updateStoreForMerc = data => {
  return post('/mercWebi/busStoreInfo/updateStoreForMerc', data)
}
//删除店铺
const deleteStoreForMerc = data => {
  return post('/mercWebi/busStoreInfo/deleteStoreForMerc', data)
}
//修改打印机
const editPrinter = data => {
  return post('/mercWebi/busStoreInfo/editPrinter', data)
}

//店铺三方系统设置列表
const thirdConfigList = data => {
  return post('/mercWebi/storeThirdConfig/thirdConfigList', data)
}
//店铺三方系统设置删除
const deleteThirdConfig = data => {
  return post('/mercWebi/storeThirdConfig/deleteThirdConfig', data)
}
//店铺三方系统设置添加，编辑
const saveThirdConfig = data => {
  return post('/mercWebi/storeThirdConfig/saveThirdConfig', data)
}
//店铺码-生成
const generateStroeCode = data => {
  return post('/mercWebi/busStoreInfo/generateCode', data)
}

//店铺-查询智能设备
const querySmartDevice = data => {
  return post('/mercWebi/busStoreInfo/querySmartDevice', data)
}
//店铺-绑定智能设备
const bindSmartDevice = data => {
  return post('/mercWebi/busStoreInfo/bindSmartDevice', data)
}
//店铺-解绑智能设备
const unBindSmartDevice = data => {
  return post('/mercWebi/busStoreInfo/unBindSmartDevice', data)
}

//店铺-营业时间保存
const storeBusinessSave = data => {
  return post('/mercWebi/storeBusinessSet/save', data)
}
//店铺-营业时间列表
const storeBusinessList = data => {
  return post('/mercWebi/storeBusinessSet/queryList', data)
}
//店铺-营业时间删除
const storeBusinessDelete = data => {
  return post('/mercWebi/storeBusinessSet/deleteById', data)
}
//店铺-查询工厂店铺列表
const queryStoreFactoryList = data => {
  return post('/mercWebi/busStoreInfo/queryStoreFactoryList', data)
}
//店铺-店铺绑定工厂
const storeBindFactory = data => {
  return post('/mercWebi/busStoreInfo/bindFactory', data)
}

// 无人收衣舱店铺-绑定服务中心
const bindServiceStore = data => {
  return post('/mercWebi/busStoreInfo/bindServiceStore', data)
}
// 无人收衣舱店铺-解绑绑定服务中心
const unbindServiceStore = data => {
  return post('/mercWebi/busStoreInfo/unbindServiceStore', data)
}

// 查询外部工厂信息
const queryFactoryByStoreCode = data => {
  return post('/mercWebi/busStoreInfo/queryFactoryByStoreCode', data)
}

// 店铺-修改参数
const updateStoreParam = data => {
  return post('/mercWebi/busStoreInfo/updateStoreParam', data)
}

export default {
  listStoreInfoByMercId,
  getStoreDownList,
  getApplicaStore,
  channalList,
  queryStoresListForMerc,
  insertStoreForMerc,
  listStoreById,
  updateStoreForMerc,
  deleteStoreForMerc,
  editPrinter,
  thirdConfigList,
  deleteThirdConfig,
  saveThirdConfig,
  generateStroeCode,
  querySmartDevice,
  bindSmartDevice,
  unBindSmartDevice,
  storeBusinessSave,
  storeBusinessList,
  storeBusinessDelete,
  queryStoreFactoryList,
  storeBindFactory,
  bindServiceStore,
  unbindServiceStore,
  queryFactoryByStoreCode,
  updateStoreParam
}
